// extracted by mini-css-extract-plugin
export default {"content":"Transactions_content__PdXFQ"};